<template>
  <VCard
    flat
    class="d-flex flex-column justify-center align-center grey lighten-4 fill-height pt-6 pt-lg-9 pb-6 pb-lg-9 px-2" width="100%"
  >
    <img src="../../assets/img/interview/clock.svg">
    <span class="subitle-1 text-center mt-6 font-weight-medium">
      {{ $t('videoProcessing') }}
    </span>
    <span class="body-2 text-center mt-2 grey--text text--darken-1">
      {{ $t('processingTip') }}
      <br>
      {{ $t('processingTip2') }}
    </span>
  </VCard>
</template>

<script>
export default {
  name: 'CandidateInterviewProcessing',
};
</script>

<i18n locale="en" lang="yaml">
  videoProcessing: Video is processing
  processingTip: It can take several minutes.
  processingTip2: Please be patient.
</i18n>

<i18n locale="ru" lang="yaml">
  videoProcessing: Видео в процессе обработки
  processingTip: Это может занять несколько минут.
  processingTip2: Наберитесь терпения, это того стоит.
</i18n>
